import ListProcesses from "@/views/agro_exporter/production/query_container_export/ListProcesses.vue";
import ShowProcess from "@/views/agro_exporter/production/query_container_export/ShowProcess.vue";
import ShowProcessContainers from "@/components/views/agro_exporter/production/query_container_export/show_process/Containers.vue";
import ShowProcessExportations from "@/components/views/agro_exporter/production/query_container_export/show_process/Exportations.vue";
import ShowProcessSchedule from "@/components/views/agro_exporter/production/query_container_export/show_process/Schedule.vue";
import ShowContainer from "@/views/agro_exporter/production/query_container_export/ShowContainer.vue";
import ShowExportation from "@/views/agro_exporter/production/query_container_export/ShowExportation.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "ae",
  role: "production",
  permission: "query_container_export"
});

export default [
  {
    path: "/ae/:agro_exporter_id/production/query_container_export/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/ae/:agro_exporter_id/production/query_container_export/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/production/query_container_export/show_process/:agro_exporter_process_id",
    name: routeName("show_process"),
    redirect: { name: routeName("show_process_containers") },
    component: ShowProcess,
    props: true,
    meta: META,
    children: [
      {
        path: "exportations",
        name: routeName("show_process_exportations"),
        alias: "",
        component: ShowProcessExportations,
        props: true
      },
      {
        path: "containers",
        name: routeName("show_process_containers"),
        component: ShowProcessContainers,
        props: true
      },
      {
        path: "schedule",
        name: routeName("show_process_schedule"),
        component: ShowProcessSchedule,
        props: true
      }
    ]
  },
  {
    path: "/ae/:agro_exporter_id/production/query_container_export/show_container/:agro_exporter_process_id/:container_id",
    name: routeName("show_container"),
    component: ShowContainer,
    props: true,
    meta: META
  },
  {
    path: "/ae/:agro_exporter_id/production/query_container_export/show_exportation/:agro_exporter_process_id/:exportation_id",
    name: routeName("show_exportation"),
    component: ShowExportation,
    props: true,
    meta: META
  }
];
